import actionTypes from '../constants/action-types';

const saveMutation = (mutation) => ({
  type: actionTypes.SAVE_MUTATION,
  payload: {
    mutation,
  },
});

export default saveMutation;
